"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PluginDecorator", {
  enumerable: true,
  get: function get() {
    return _ContentBlocks.PluginDecorator;
  }
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _PagesList = _interopRequireDefault(require("./components/PagesList"));

var _ArticlesList = _interopRequireDefault(require("./components/ArticlesList"));

var _TemplatesList = _interopRequireDefault(require("./components/TemplatesList"));

var _ElementsList = _interopRequireDefault(require("./components/ElementsList"));

var _ArticleCategoryList = _interopRequireDefault(require("./components/ArticleCategories/ArticleCategoryList"));

var _ArticleCategoryAdd = _interopRequireDefault(require("./components/ArticleCategories/ArticleCategoryAdd"));

var _ArticleCategoryEdit = _interopRequireDefault(require("./components/ArticleCategories/ArticleCategoryEdit"));

var _ArticleCategoryForm = _interopRequireDefault(require("./components/ArticleCategories/ArticleCategoryForm"));

var _ElementAreasList = _interopRequireDefault(require("./components/ElementAreas/ElementAreasList"));

var _ElementAreasEdit = _interopRequireDefault(require("./components/ElementAreas/ElementAreasEdit"));

var _ElementAreasForm = _interopRequireDefault(require("./components/ElementAreas/ElementAreasForm"));

var _Editor = _interopRequireDefault(require("./Editor"));

var _ContentBlocks = require("./Editor/ContentBlocks");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defaults = {
  PagesList: _PagesList["default"],
  ArticlesList: _ArticlesList["default"],
  TemplatesList: _TemplatesList["default"],
  ElementsList: _ElementsList["default"],
  ArticleCategoryList: _ArticleCategoryList["default"],
  ArticleCategoryAdd: _ArticleCategoryAdd["default"],
  ArticleCategoryEdit: _ArticleCategoryEdit["default"],
  ArticleCategoryForm: _ArticleCategoryForm["default"],
  ElementAreasList: _ElementAreasList["default"],
  ElementAreasEdit: _ElementAreasEdit["default"],
  ElementAreasForm: _ElementAreasForm["default"]
};

var _default = function _default() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var components = _objectSpread(_objectSpread({}, defaults), options);

  var PagesList = components.PagesList,
      ArticlesList = components.ArticlesList,
      TemplatesList = components.TemplatesList,
      ElementsList = components.ElementsList,
      ArticleCategoryList = components.ArticleCategoryList,
      ArticleCategoryAdd = components.ArticleCategoryAdd,
      ArticleCategoryEdit = components.ArticleCategoryEdit,
      ArticleCategoryForm = components.ArticleCategoryForm,
      ElementAreasList = components.ElementAreasList,
      ElementAreasEdit = components.ElementAreasEdit,
      ElementAreasForm = components.ElementAreasForm;
  return {
    routes: [{
      path: '/pages',
      render: function render(_ref) {
        var match = _ref.match;
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url),
          exact: true,
          component: PagesList
        }));
      }
    }, {
      path: '/articles',
      render: function render(_ref2) {
        var match = _ref2.match;
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url),
          exact: true,
          component: ArticlesList
        }));
      }
    }, {
      path: '/article-categories',
      render: function render(_ref3) {
        var match = _ref3.match;
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url),
          exact: true,
          component: ArticleCategoryList
        }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url, "/add"),
          exact: true
        }, function (props) {
          return /*#__PURE__*/_react["default"].createElement(ArticleCategoryAdd, _extends({}, props, {
            ArticleCategoryForm: ArticleCategoryForm
          }));
        }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url, "/:id"),
          exact: true
        }, function (props) {
          return /*#__PURE__*/_react["default"].createElement(ArticleCategoryEdit, _extends({}, props, {
            ArticleCategoryForm: ArticleCategoryForm
          }));
        }));
      }
    }, {
      path: '/templates',
      render: function render(_ref4) {
        var match = _ref4.match;
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url),
          exact: true,
          component: TemplatesList
        }));
      }
    }, {
      path: '/elements',
      render: function render(_ref5) {
        var match = _ref5.match;
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url),
          exact: true,
          component: ElementsList
        }));
      }
    }, {
      path: '/element-areas',
      render: function render(_ref6) {
        var match = _ref6.match;
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url),
          exact: true,
          component: ElementAreasList
        }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url, "/:id"),
          exact: true
        }, function (props) {
          return /*#__PURE__*/_react["default"].createElement(ElementAreasEdit, _extends({}, props, {
            ElementAreasForm: ElementAreasForm
          }));
        }));
      }
    }, {
      path: '/content/edit/:type/:id?',
      render: function render(_ref7) {
        var match = _ref7.match;
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.path),
          component: function component(props) {
            return /*#__PURE__*/_react["default"].createElement(_Editor["default"], props);
          }
        }));
      }
    }]
  };
};

exports["default"] = _default;